import { RepositoryFactory } from '@/repositories/factory'

export default (_, inject) => {
  const repositories = (name) => {
    return RepositoryFactory.get(name)
  }
  inject('repositories', repositories)
}